import { deviceMapper } from './mapper';
import {
  NpvrActions,
  NpvrPayload,
  NpvrState
} from './types';

const initialState: NpvrState = {
  items: [],
  totalElements: 0,
  timelineItems: [],
  householdDevicesItems: { devices: [] },
};

export default function (state = initialState, action: NpvrPayload) {
  switch (action.type) {
    case NpvrActions.setNpvrInfo:
      return {
        ...state,
        items: action.payload.items,
        totalElements: action.payload.totalElements ? parseInt(action.payload.totalElements) : 0,
      };
    case NpvrActions.clearNpvrInfo:
      return initialState;
    case NpvrActions.setTimelineInfo:
      return {
        ...state,
        timelineItems: action.payload,
      };
    case NpvrActions.setDevicesInfo:
      return {
        ...state,
        householdDevicesItems: { devices: deviceMapper(action.payload.devices, action.payload.t) },
      };
    default: {
      return { ...state };
    }
  }
}
